import './App.css'
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Dashboard from './Pages/Dashboard'
import DeleteTenant from './Components/Tenants/DeleteTenant'
import MainMenu from './Components/MainMenu/MainMenu'
import AuthenticatedRoute from './Components/Auth/AuthenticatedRoute'
import { useIsAuthenticated } from '@azure/msal-react'
import FeatureFlagPage from './Pages/FeatureFlagPage'
import { Main, Wrapper, Aside } from './Components/StyledComponents/Components'
import { AuthRoleContextProvider } from './Components/Auth/AuthRoleContext'
import { SystemStatusProvider } from './Components/Context/SystemStatusContext'
import MaintenanceBanner from './Components/Common/MaintenanceBanner'
import BulkUpdate from './Pages/BulkUpdate'
import StageRollout from './Pages/StageRollout'
import TenantConfigMigration from './Pages/TenantConfigMigration'
import CertificateIssuers from './Pages/CertificateIssuers'
import CertificateRequests from './Pages/CertificateRequests'
import AdvancedSearch from './Pages/AdvancedSearch'
import DeveloperCenter from './Pages/DeveloperCenter'
import { DEVELOPER_CENTER_PATH } from './Components/MainMenu/navigation'
import ModulesOverview from './Pages/ModulesOverview'
import Reports from './Pages/Reports'
import Settings from './Pages/Settings'
import { Tooltip } from 'react-tooltip'
import Login from './Pages/Login'
import { useEffect } from 'react'

function AppContent() {
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()
  const location = useLocation()

  // Handle redirect after login
  useEffect(() => {
    const storedUrl = sessionStorage.getItem('redirectAfterLogin')
    console.log('[App] Redirect check:', {
      isAuthenticated,
      pathname: location.pathname,
      storedUrl
    })

    if (isAuthenticated && storedUrl) {
      // If we're not already at the stored URL, navigate to it
      if (storedUrl !== '/' && storedUrl !== location.pathname) {
        console.log('[App] Redirecting to stored URL:', storedUrl)
        navigate(storedUrl, { replace: true })
      }
      // Clear the stored URL after we've used it (or if we're already there)
      console.log('[App] Clearing stored URL from sessionStorage')
      sessionStorage.removeItem('redirectAfterLogin')
    }
  }, [isAuthenticated, location.pathname, navigate])

  return (
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route
        path='*'
        element={
          <Wrapper>
            <Aside>
              <MainMenu />
            </Aside>
            <Main>
              <Routes>
                <Route path='/' element={<AuthenticatedRoute component={Dashboard} />} />
                <Route path='/subscriptions' element={<AuthenticatedRoute component={Dashboard} />} />
                <Route path='/subscriptions/:subscriptionid' element={<AuthenticatedRoute component={Dashboard} />} />
                <Route path='/subscriptions/:subscriptionid/tenant/:tenantid' element={<AuthenticatedRoute component={Dashboard} />} />
                <Route path='/search' element={<AuthenticatedRoute component={AdvancedSearch} />} />
                <Route path={DEVELOPER_CENTER_PATH} element={<AuthenticatedRoute component={DeveloperCenter} />} />
                <Route path='/modules' element={<AuthenticatedRoute component={ModulesOverview} />} />
                <Route path='/feature-flags' element={<AuthenticatedRoute component={FeatureFlagPage} />} />
                <Route path='/bulk-update' element={<AuthenticatedRoute component={BulkUpdate} />} />
                <Route path='/rollout' element={<AuthenticatedRoute component={StageRollout} />} />
                <Route path='/config-migration' element={<AuthenticatedRoute component={TenantConfigMigration} />} />
                <Route path='/certificates' element={<AuthenticatedRoute component={CertificateIssuers} />} />
                <Route path='/certificates/requests' element={<AuthenticatedRoute component={CertificateRequests} />} />
                <Route path='/reports' element={<AuthenticatedRoute component={Reports} />} />
                <Route path='/settings' element={<AuthenticatedRoute component={Settings} />} />
                <Route path='/tenant/delete/:tenantId' element={<AuthenticatedRoute component={DeleteTenant} />} />
              </Routes>
            </Main>
          </Wrapper>
        }
      />
    </Routes>
  )
}

function App() {
  return (
    <AuthRoleContextProvider>
      <Router>
        <SystemStatusProvider>
          <MaintenanceBanner />
          <AppContent />
        </SystemStatusProvider>
        <Tooltip
          id='global-tooltip'
          className='custom-tooltip'
          style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            fontSize: '12px',
            fontWeight: '500',
            zIndex: 9999
          }}
        />
      </Router>
    </AuthRoleContextProvider>
  )
}

export default App
